import request from '@comm/utils/request'

/**
 * 文件上传
 * @param {*} data
 * @returns
 */
export function uploadFile(data) {
	return request({
		url: "/pubelec/api/electronic_certificate/upload/v1",
		method: "post",
		headers: {
			"Content-Type": "multipart/form-data"
		},
		data
	});
}

/**
 * 提取元数据，下载excel
 * @param {*} data
 * @returns
 */
export function extractMetadata(data,isUpload) {
	return request({
		url: `/pubelec/api/electronic_certificate/get_metadatas/${isUpload?'':'example/'}v1`,
		method: "post",
		responseType: "blob",
		data
	});
}

/**
 * 提取xbrl附件，多个压缩包下载，单个直接下载
 * @param {*} data
 * @returns
 */
export function extractXBRLdata(data,isUpload) {
	return request({
		url: `/pubelec/api/electronic_certificate/get_attachments/${isUpload?'':'example/'}v1`,
		method: "post",
		responseType: "blob",
		data
	});
}

/**
 * 签章验证
 * @param {*} data
 * @returns
 */
export function verifySignature(data,isUpload) {
	return request({
		url: `/pubelec/api/electronic_certificate/verify_signature/${isUpload?'':'example/'}v1`,
		method: "post",
		data
	});
}

/**
 * 下载图片，多个压缩包下载，单个直接下载
 * @param {*} data
 * @returns
 */
export function downloadPicture(data,isUpload) {
	return request({
		url: `/pubelec/api/electronic_certificate/convert/${isUpload?'':'example/'}v1`,
		method: "post",
		responseType: "blob",
		data
	});
}

/**
 * 下载图片，多个压缩包下载，单个直接下载
 * @param {*} params
 * @returns
 */
export function checkIssueData(params) {
	return request({
		url: "/pubelec/api/template_compose/check/v1",
		method: "get",
		params
	});
}



// WEBPACK FOOTER //
// ./src/comm/api/document-conversion/usetake.js